import { render, staticRenderFns } from "./Paquetes.vue?vue&type=template&id=07b82a28&scoped=true"
import script from "./Paquetes.vue?vue&type=script&lang=js"
export * from "./Paquetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b82a28",
  null
  
)

export default component.exports